module.exports = __webpack_public_path__ + "media/images/nav/icon_3-d50cfb02a8037b20ad6d225dd8f9c66b.svg";